import { ArrowRightIcon, LinkIcon } from "@heroicons/react/outline";
import React, { useContext, useState } from "react";
import { UserContext } from "../containers/UserProvider";

export const BookmarksPage = () => {
  const user = useContext(UserContext);
  const [search, setSearch] = useState("");

  return (
    <div className="w-full text-white ">
      <div className="h-96 overflow-auto">
        <input
          className="shadow appearance-none mt-3 border-gray-700 rounded w-full py-2 px-3 bg-gray-600 text-white-700 leading-tight focus:outline-none focus:shadow-outline"
          type="text"
          onChange={(e) => setSearch(e.target.value)}
          value={search}
          placeholder="Search.."
        />
        {user.bookmarkedThreads.length === 0 && (
          <div>You have no bookmarks yet.</div>
        )}
        {user.bookmarkedThreads
          ?.filter((thread) => {
            return (
              thread.title.toLowerCase().indexOf(search.toLowerCase()) != -1 ||
              thread.url.toLowerCase().indexOf(search.toLowerCase()) != -1
            );
          })
          .map((bookmark) => (
            <p
              href={bookmark.url}
              target="_blank"
              className="flex items-center mt-3 px-4 py-4 rounded-lg bg-gray-600 cursor-pointer focus:outline-none  text-ellipsis overflow-hidden"
              rel="noreferrer"
              key={bookmark}
            >
              <div className="flex-none text-ellipsis overflow-hidden">
                <div className="flex">
                  <img
                    src={`http://www.google.com/s2/favicons?domain=${bookmark.url}`}
                    className="w-5 h-5 mr-2"
                  />
                  <p className="">
                    {bookmark.title.substring(0, 30) +
                      (bookmark.title.length > 30 ? "..." : "")}{" "}
                    &nbsp;&nbsp;
                  </p>
                </div>
              </div>
              <div className="flex-grow"></div>
              <div className="flex-none">
                <ArrowRightIcon className=" w-5 h-5" />
              </div>
            </p>
          ))}
      </div>
    </div>
  );
};
